/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyMicrodepositsRequest
 */
export interface VerifyMicrodepositsRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyMicrodepositsRequest
     */
    setupIntentId: string;
    /**
     * 
     * @type {number}
     * @memberof VerifyMicrodepositsRequest
     */
    firstAmountCents: number;
    /**
     * 
     * @type {number}
     * @memberof VerifyMicrodepositsRequest
     */
    secondAmountCents: number;
}

/**
 * Check if a given object implements the VerifyMicrodepositsRequest interface.
 */
export function instanceOfVerifyMicrodepositsRequest(value: object): value is VerifyMicrodepositsRequest {
    if (!('setupIntentId' in value) || value['setupIntentId'] === undefined) return false;
    if (!('firstAmountCents' in value) || value['firstAmountCents'] === undefined) return false;
    if (!('secondAmountCents' in value) || value['secondAmountCents'] === undefined) return false;
    return true;
}

export function VerifyMicrodepositsRequestFromJSON(json: any): VerifyMicrodepositsRequest {
    return VerifyMicrodepositsRequestFromJSONTyped(json, false);
}

export function VerifyMicrodepositsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyMicrodepositsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'setupIntentId': json['setupIntentId'],
        'firstAmountCents': json['firstAmountCents'],
        'secondAmountCents': json['secondAmountCents'],
    };
}

  export function VerifyMicrodepositsRequestToJSON(json: any): VerifyMicrodepositsRequest {
      return VerifyMicrodepositsRequestToJSONTyped(json, false);
  }

  export function VerifyMicrodepositsRequestToJSONTyped(value?: VerifyMicrodepositsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'setupIntentId': value['setupIntentId'],
        'firstAmountCents': value['firstAmountCents'],
        'secondAmountCents': value['secondAmountCents'],
    };
}

